const getDefaultState = () => {
	return {
		index: [],
	}
}

export const state = () => ({
	index: [],
})

export const mutations = {
	SET_INDEX(state, docs) {
		state.index = docs
	},
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
}

export const actions = {
	async bindIndex({ commit }) {
		const ref = this.$fire.firestore.collection("trades").orderBy("title", "asc")
		ref.onSnapshot((snapshot) => {
			const docs = snapshot.docs.map((doc) => ({
				id: doc.id,
				title: doc.data().title,
			}))
			commit("SET_INDEX", docs) // Always use commit to change state
		})
	},
	reset({ commit, dispatch }) {
		commit("RESET_STATE")
	},
}

export const getters = {
	getIndex(state) {
		return state.index
	},
	getLabelledIndex(state) {
		const transformed = state.index.map(({ title, id }) => ({
			label: title,
			value: id,
		}))
		return transformed
	},
	getFilterOptions(state) {
		return state.index.map(({ title, id }) => ({
			label: title,
			value: title,
		}))
	},
}
